import { UserRolesTypes } from 'common/user-role-types';
import { getUserRoles as getKeycloakUserRoles } from './keycloak-adapter';

export const allPermissionRoles = [
  UserRolesTypes.ADMIN,
  UserRolesTypes.FINANCIER,
  UserRolesTypes.CUSTOMER_OPERATOR,
  UserRolesTypes.CUSTOMER_SUPERVISOR,
  UserRolesTypes.CUSTOMER_OWNER,
];

export const getUserRoles = () => {
  return getKeycloakUserRoles();
};

export const userHasPermissions = (permissions: UserRolesTypes[]): boolean => {
  return getUserRoles().some((role) => permissions.includes(role as any));
};

export const isUserAdmin = (): boolean => userHasPermissions([UserRolesTypes.ADMIN]);
export const isUserFinancier = (): boolean => userHasPermissions([UserRolesTypes.FINANCIER]);
export const isUserCustomer = (): boolean =>
  userHasPermissions([UserRolesTypes.CUSTOMER_OPERATOR, UserRolesTypes.CUSTOMER_SUPERVISOR, UserRolesTypes.CUSTOMER_OWNER]);
export const isUserCustomerSupervisor = (): boolean => userHasPermissions([UserRolesTypes.CUSTOMER_SUPERVISOR]);
export const isUserCustomerOperator = (): boolean => userHasPermissions([UserRolesTypes.CUSTOMER_OPERATOR]);
export const isUserCustomerOwner = (): boolean => userHasPermissions([UserRolesTypes.CUSTOMER_OWNER]);
